module.exports = __webpack_public_path__ + "img/5.d5a82264.png";